import React from 'react';
import { Box, Flex } from '@mantine/core';
import DynamicNonFinancialDataFields from './DynamicNonFinancialDataFields';

export default function NonFinancialDataContent() {
  return (
    <Flex direction={'row'} justify={'stretch'}>
      <Box flex={1}>
        <DynamicNonFinancialDataFields />
      </Box>
    </Flex>
  );
}
